import { Component, OnInit, Input } from '@angular/core';

/**
 * Component per mostrar el marcador d'un parking del tipus Park & Ride
 */ 
@Component({
  selector: 'app-park-nride',
  templateUrl: './park-nride.component.html',
  styleUrls: ['./park-nride.component.css']
})
export class ParkNRideComponent implements OnInit {

  /**
   * Feature que conté les propietats per crear el marcador
   */
  @Input() feature;

  /**
   * Capa a la qual pertany el marcador
   */
  @Input() layer;

  /**
   * Conté les propietats del feature
   */
  properties;

  /**
   * Url de la icona a mostrar
   */
  iconUrl: string;

  /**
   * Nom de la estació a la qual pertany el Park&Ride
   */
  station: string

  /**
   * Capacitat del pàrking
   */
  size: number; 

  /**
   * Operador del pàrking
   */
  operador: string;

   /**
   * Ocupació del pàrking
   */
  occupied: number; 

  /**
   * @ignore
   */
  constructor() { }

  /**
   * Inicialitza les propietats del marcador
   */
  ngOnInit() {

    this.properties = this.feature.properties;
    this.iconUrl = this.iconUrl = 'assets/img/' + this.layer + '_MARKER.svg';
    this.station = this.properties.nomEst;
    this.size = this.properties.nrPlaces;
    this.operador = this.properties.operador;
    this.occupied = this.properties.plOcupades;

  }

}
